import NotImplemented from "../../../../../exceptions/not-implemented";
import FootballSerializer from "../../../FootballSerializer";

export class FragmentSerializer {
    getRawFragment() {
        throw new NotImplemented();
    }

    isCommentSerializer() {
        return false;
    }

    getTypeCode() {
        return null;
    }

    getComment() {
        return null;
    }

    applicable() {
        return false;
    }

    resolveUniform(serializationContext, fragmentPlayer) {
        const { awayPlayers, homePlayers } = serializationContext;
        return [...awayPlayers, ...homePlayers].find(
            (p) => p.id === fragmentPlayer.id
        )?.uniform;
    }

    resolveTeam(serializationContext, fragmentPlayer) {
        const { gameContext } = serializationContext;
        return fragmentPlayer.teamId === gameContext.homeTeamId ? "H" : "V";
    }

    resolveOpponent(serializationContext, fragmentPlayer) {
        const { gameContext } = serializationContext;
        return fragmentPlayer.teamId === gameContext.homeTeamId ? "V" : "H";
    }

    resolveFormattedFieldPosition(serializationContext, position) {
        const { gameContext } = serializationContext;
        const formattedPosition = FootballSerializer._formatFieldPosition(
            gameContext.gameConfig.general.fieldLength,
            position
        );
        return `${formattedPosition[0]}${formattedPosition
            .slice(1)
            .padStart(2, "0")}`;
    }
}
